document.addEventListener("DOMContentLoaded", () => {
    const sortSelect = document.getElementById("sort-by");
    if (!sortSelect) return;

    sortSelect.addEventListener("change", () => {
        const params = new URLSearchParams(window.location.search);

        if (sortSelect.value) {
            params.set("sortBy", sortSelect.value);
        } else {
            params.delete("sortBy");
        }
        params.delete("page");

        window.location.search = params.toString();
    });
});
